import BlogPagination from './BlogPagination';

export default BlogPagination;
